<template>
    <div class="overflow-hidden w-full px-10" style="max-width: 600px;margin-top: -80px;margin-bottom: -80px;">
        <canvas id="homeAnimation" width="600" height="545"></canvas>
    </div>    
</template>

<script>
export default {
	mounted: function () {
		let image = new Image();

		image.src = require('@/assets/img/home/sprite.jpg');

		let counter = 0,
			frame_width = 600,
			frame_height = 454;

		image.onload = function () {
			let canvas = document.getElementById("homeAnimation");
			let context = canvas.getContext("2d");

			context.drawImage(image, 0, 0, frame_width, frame_height, 0, 0, frame_width, frame_height);

			// Check if canvas visible
			let neverSeen = true;

			window.addEventListener('scroll', function () {
				var position = canvas.getBoundingClientRect();

				// checking whether fully visible
				if (neverSeen && position.top >= 0 && position.bottom <= window.innerHeight) {
					window.requestAnimationFrame(animate)
					neverSeen = false;
				}
			});

			let positions = [];

			[0, 1, 2, 3, 4, 5, 6].forEach(function (y) {
				[0, 1, 2, 3, 4, 5, 6].forEach(function (x) {
					positions.push({
						x: x * 600,
						y: y * 474
					});
				});
			});

			let position = 0;

			function animate() {
				setTimeout(function () {
					let frame = Math.floor(counter % 8);

					context.drawImage(image, positions[position].x, positions[position].y, frame_width, frame_height, 0, 0, frame_width, frame_height);

					if (position < positions.length - 1) {
						position++;
						window.requestAnimationFrame(animate);
					}
				}, 30);
			}
		}
	}
}
</script>